import Api from './Api'

const endpoint = 'cities'

export default class CityService extends Api{

    async all (filter) {
        const response = await this.client.get(`${endpoint}/all`,{
            params: {
                field: 'name',
                value: filter
            }
        });
        if (response.data) {
            return response.data.map(s => {
                return {
                    value: s.id,
                    text: s.name.concat(' - ', s.state_name)
                }
            })
        }
        throw new Error('No data')
    }

    async allByState (filter, stateId) {
        const response = await this.client.get(`${endpoint}/all`,{
            params: {
                field: 'name',
                value: filter,
                parent_field: 'state_id',
                parent_value: stateId
            }
        });
        if (response.data) {
            return response.data.map(s => {
                return {
                    value: s.id,
                    text: s.name
                }
            })
        }
        throw new Error('No data')
    }

    async allByInState (states) {

        const response = await this.client.get(`states/${endpoint}`,{
            params: {
                state_id: states
            }
        });

        if (response.data) {
            return response.data.map(s => {
                return {
                    value: s.id,
                    text: s.name
                }
            })
        }
        throw new Error('No data')
    }
}
